<dx-list [dataSource]="dataSource"
         [selectionMode]="singleSelection ? 'single' : 'multiple'"
         [showSelectionControls]="true"
         [selectByClick]="true"
         [selectedItemKeys]="selectedTeamIds"
         (onSelectionChanged)="onSelectionChanged($event)"
         [searchEnabled]="true"
         [searchExpr]="searchTeamFunction"
         pageLoadMode="scrollBottom">
    <div *dxTemplate="let team of 'item'"
         class="d-flex align-items-center gap-2">
        @if (team) {
            <i class="fal fa-fw fa-users"
               adaptTooltip="team"></i>
            <span>{{team.name}}</span>
        } @else {
            <i class="fal fa-fw fa-cubes"
               adaptTooltip="organisation"></i>
            <span>Organisation</span>
        }
    </div>
</dx-list>
